import { CompletedCollectible } from "@/types/highlights"
import Button from "components/Button"
import ErrorMessage from "components/Collectibles/ErrorMessage"
import RainbowConnectWalletBtn from "components/RainbowConnectWalletBtn"
import SwitchChainButton from "components/SwitchChainButton"
import { selectBlog } from "features/blogSlice"
import { selectCurrentNote } from "features/noteSlice"
import { retrieveHighlights } from "features/pageSlice"
import useMintExistingHighlight from "hooks/crypto/highlights/useMintExistingHighlight"
import useUser from "hooks/useUser"
import { ReactNode, useEffect } from "react"
import { useSelector } from "react-redux"
import { useAppDispatch } from "store"
import { useAnalytics } from "hooks/useAnalytics"
import { getChainId } from "@/util/crypto"
import { useWaitForTransaction } from "wagmi"

import ShareButtons from "components/ShareButtons"
import useNoteUrl from "hooks/useNoteUrl"
import { RiSparkling2Fill } from "react-icons/ri"

function Text({ children }: { children: ReactNode }) {
  return <div className="text-gray-500 text-sm mt-2">{children}</div>
}
export default function CollectExistingCollectibleBtn(props: {
  btnText?: string
  highlight: CompletedCollectible
  disabled?: boolean
}) {
  const note = useSelector(selectCurrentNote)
  const blog = useSelector(selectBlog)

  const dispatch = useAppDispatch()
  const { track } = useAnalytics()
  const user = useUser()

  let { fullNoteUrl } = useNoteUrl({ blog, note })

  if ("wallet_address" in user && user.wallet_address) {
    fullNoteUrl = fullNoteUrl + "?referrer=" + user.wallet_address
  }

  const { data, buy, isLoading, error } = useMintExistingHighlight({
    highlight: props.highlight,
  })

  console.log("Waiting for transaction with data hash", data?.hash)

  const waitForTransaction = useWaitForTransaction({
    hash: data?.hash,
    chainId: getChainId(props.highlight.chain),
  })

  console.log("[Collect Existing] data", data, props.highlight)

  useEffect(() => {
    if (!waitForTransaction.isSuccess || !note?.id || !props.highlight.id) {
      console.warn("Waiting for transaction to succeed...")
      return
    }

    track("highlight existing mint successful", {
      highlight: props.highlight,
    })

    dispatch(retrieveHighlights(note.id))
  }, [waitForTransaction.isSuccess])

  useEffect(() => {
    if (!error) return

    console.error("Error collecting existing collectible", error)

    track("error collecting existing collectible", {
      error,
    })
  }, [error])

  return (
    <div className="flex justify-center flex-col w-full">
      {!user.walletReadyAndLoggedIn && (
        <>
          <RainbowConnectWalletBtn text="Connect wallet" />
        </>
      )}
      {user.walletReadyAndLoggedIn && !waitForTransaction?.isSuccess && (
        <Button
          type="button"
          loading={isLoading || waitForTransaction.isLoading}
          disabled={
            props.disabled ||
            (!!error && error.message !== "User rejected request")
          }
          onClick={async () => {
            if (!blog?.id || !note?.id) return

            console.log("Triggering buy...")

            buy()
          }}
        >
          {props.btnText || "Collect highlight"}
          <RiSparkling2Fill className="ml-2" />
        </Button>
      )}

      {/* Only display the error message if the user doesn't already own */}
      {error && (
        <>
          <ErrorMessage error={error} />
          <SwitchChainButton chain={props.highlight.chain} />
        </>
      )}

      {waitForTransaction.isLoading && <Text>Waiting for transaction...</Text>}

      {waitForTransaction.isSuccess && (
        <>
          <Text>Successfully collected! Share:</Text>

          <ShareButtons
            url={fullNoteUrl}
            socialMediaShareText={`I just collected ${props.highlight.text} on Paragraph.`}
          />
        </>
      )}
    </div>
  )
}
